import { QuestionType } from "@prisma/mongoClient";
export default QuestionType;
